(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9574],{

/***/ 97669:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forum/[[...params]]",
      function () {
        return __webpack_require__(29294);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 62307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ useDefaultTopLayout; }
/* harmony export */ });
/* unused harmony export useHomePageDefaultLayout */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99456);
/* harmony import */ var _default_layout_DefaultLayout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78485);
/* harmony import */ var _dashboard_navbar_DashboardNavbar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51938);




var useDefaultTopLayout = function(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_1__/* .DefaultTopNavLayout */ .U1, {
        children: page
    });
};
var useHomePageDefaultLayout = function(page) {
    return /*#__PURE__*/ _jsx(DefaultLayout, {
        navContent: /*#__PURE__*/ _jsx(DashboardNav, {}),
        children: page
    });
};


/***/ }),

/***/ 24145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GW": function() { return /* binding */ getWhyChooseUsPageLayout; },
/* harmony export */   "Y$": function() { return /* binding */ getAboutUsPageLayout; },
/* harmony export */   "ad": function() { return /* binding */ getHowVahakHelpsPageLayout; },
/* harmony export */   "m2": function() { return /* binding */ getDefaultTopLayout; },
/* harmony export */   "sA": function() { return /* binding */ getContactUsPageLayout; }
/* harmony export */ });
/* unused harmony export getHomePageLayout */
/* harmony import */ var components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62307);

/***
 *  Default Layout
 */ var getDefaultTopLayout = components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_0__/* .useDefaultTopLayout */ .E;
/***
 * About Us
 */ var getAboutUsPageLayout = components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_0__/* .useDefaultTopLayout */ .E;
/***
 * how vahak helps
 */ var getHowVahakHelpsPageLayout = components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_0__/* .useDefaultTopLayout */ .E;
/***
 * Contact Us
 */ var getContactUsPageLayout = components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_0__/* .useDefaultTopLayout */ .E;
/***
 * Whu Choose Us
 */ var getWhyChooseUsPageLayout = components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_0__/* .useDefaultTopLayout */ .E;
/***
 * Home
 */ var getHomePageLayout = (/* unused pure expression or super */ null && (useHomePageDefaultLayout));


/***/ }),

/***/ 29294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Forum; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/service-pages/constants/company-pages-methods.ts
var company_pages_methods = __webpack_require__(24145);
// EXTERNAL MODULE: ./components/utils/AppImg.tsx
var AppImg = __webpack_require__(17073);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/index.js
var Typography = __webpack_require__(71960);
// EXTERNAL MODULE: ../core-ui/dist/components/Button/index.js
var Button = __webpack_require__(32450);
// EXTERNAL MODULE: ../core/dist/constants/routeStrings.js
var routeStrings = __webpack_require__(12098);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./components/seo-header/NoIndexHeader.tsx



var NoIndexHeader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "robots",
            content: "noindex, nofollow"
        })
    });
};
/* harmony default export */ var seo_header_NoIndexHeader = (NoIndexHeader);

;// CONCATENATED MODULE: ./pages/forum/[[...params]].tsx



// Components




//Constants

//AppContext


var __N_SSP = true;
function Forum() {
    var router = (0,next_router.useRouter)();
    var isPhoneVerified = (0,react.useContext)(app_context/* AppContext */.Il).isPhoneVerified;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo_header_NoIndexHeader, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    height: "80vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "20px",
                    padding: "10px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                            src: "discontinued.svg",
                            layout: "fixed",
                            width: "240px",
                            height: "240px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            maxWidth: "800px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            size: "l",
                            align: "center",
                            as: "p",
                            weight: "bold",
                            children: "We have discontinued this forum. However if you have any concern or query, please reach out to our customer care"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            maxWidth: "300px",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                onClick: function() {
                                    return router.push(isPhoneVerified ? routeStrings/* ROUTES.dashboard.getUrl */.Z.dashboard.getUrl() : "/");
                                },
                                children: "Go Home"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                onClick: function() {
                                    return router.push("/contact-us");
                                },
                                children: "Contact Us"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
Forum.getLayout = company_pages_methods/* getDefaultTopLayout */.m2;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(97669); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);